// Gerador local de palpites para a página "Palpites Show" (admin).
// Não persiste nada. Baseado no formato do slide PALPITES-02-07-2026.

import { animalMapping } from "@/utils/animalImages";

export interface PalpiteOuro {
  grupo: string; // "05"
  animal: string;
  dezena: string; // "17"
  centenas: string[]; // 4
  milhares: string[]; // 4
}

export interface PasseVaiVem {
  g1: string;
  g2: string;
}

export interface DuqueTerno {
  numeros: string[];
}

export interface PalpitesData {
  data: string; // dd/mm/yyyy
  bichoDoDia: string[]; // 4 milhares
  palpitesOuro: PalpiteOuro[]; // 4
  passeVaiVem: PasseVaiVem[]; // 4
  duques: DuqueTerno[]; // 5
  ternos: DuqueTerno[]; // 5
  bonusMilhar: string;
  bonusCentena: string;
}

const rand = (min: number, max: number) => Math.floor(Math.random() * (max - min + 1)) + min;
const pad2 = (n: number) => n.toString().padStart(2, "0");
const pad3 = (n: number) => n.toString().padStart(3, "0");
const pad4 = (n: number) => n.toString().padStart(4, "0");

function todayBR(): string {
  const d = new Date();
  return `${pad2(d.getDate())}/${pad2(d.getMonth() + 1)}/${d.getFullYear()}`;
}

function grupoDezenaAleatorio(): { grupo: string; dezena: number } {
  const grupo = pad2(rand(1, 25));
  const dez = animalMapping[grupo].dezenas[rand(0, 3)];
  return { grupo, dezena: dez };
}

function gerarPalpiteOuro(grupo: string, dezena: number): PalpiteOuro {
  const dz = pad2(dezena === 0 ? 0 : dezena);
  // centenas: 4 variações com centena inicial diferente + mesma dezena
  const centenaBases = Array.from({ length: 9 }, (_, i) => i + 1);
  const chosen = centenaBases.sort(() => Math.random() - 0.5).slice(0, 4);
  const centenas = chosen.map((c) => `${c}${dz}`);

  // milhares: mesmo prefixo de 2 dígitos + variações
  const prefixo = rand(1, 9);
  const milharesBase = Array.from({ length: 9 }, (_, i) => i + 1).sort(() => Math.random() - 0.5).slice(0, 4);
  const milhares = milharesBase.map((m) => `${prefixo}${m}${dz}`);

  return {
    grupo,
    animal: animalMapping[grupo].name,
    dezena: dz,
    centenas,
    milhares,
  };
}

export function gerarPalpites(): PalpitesData {
  // Bicho do dia — 4 milhares sequenciais estilo slide (3317, 3418, 3519, 3620)
  const baseMilhar = rand(1000, 8000);
  const bichoDoDia = [0, 101, 202, 303].map((offset) => pad4((baseMilhar + offset) % 10000));

  // 4 palpites de ouro
  const palpitesOuro: PalpiteOuro[] = [];
  for (let i = 0; i < 4; i++) {
    const { grupo, dezena } = grupoDezenaAleatorio();
    palpitesOuro.push(gerarPalpiteOuro(grupo, dezena));
  }

  // Passe vai e vem
  const passeVaiVem: PasseVaiVem[] = Array.from({ length: 4 }, () => ({
    g1: pad2(rand(1, 25)),
    g2: pad2(rand(1, 25)),
  }));

  // Duques de dezenas
  const duques: DuqueTerno[] = Array.from({ length: 5 }, () => ({
    numeros: [pad2(rand(1, 99)), pad2(rand(1, 99))],
  }));

  // Ternos de dezenas
  const ternos: DuqueTerno[] = Array.from({ length: 5 }, () => ({
    numeros: [pad2(rand(1, 99)), pad2(rand(1, 99)), pad2(rand(1, 99))],
  }));

  return {
    data: todayBR(),
    bichoDoDia,
    palpitesOuro,
    passeVaiVem,
    duques,
    ternos,
    bonusMilhar: pad4(rand(1000, 9999)),
    bonusCentena: pad3(rand(100, 999)),
  };
}
